const DEFAULT_LOCALE = 'en';
const NAME_COMPARE_OPTIONS: Intl.CollatorOptions = { numeric: true, sensitivity: 'base' };

export const compareNamesAscending = (left: string, right: string, locale = DEFAULT_LOCALE): number => {
  try {
    return left.localeCompare(right, locale, NAME_COMPARE_OPTIONS);
  } catch {
    return left.localeCompare(right, DEFAULT_LOCALE, NAME_COMPARE_OPTIONS);
  }
};
